import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User, UserProfile } from '@shared/types';

interface AuthState {
  user: User | null;
  profile: UserProfile | null;
  isAuthenticated: boolean;
  setUser: (user: User | null, profile?: UserProfile | null) => void;
  setProfile: (profile: UserProfile | null) => void;
  logout: () => void;
  isAdmin: () => boolean;
  isProfesional: () => boolean;
  isPaciente: () => boolean;
  isImpersonating: () => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      profile: null,
      isAuthenticated: false,
      
      setUser: (user, profile) => set({ 
        user, 
        profile: profile || null, 
        isAuthenticated: !!user 
      }),
      
      setProfile: (profile) => set({ profile }),
      
      logout: () => set({ 
        user: null, 
        profile: null, 
        isAuthenticated: false 
      }),
      
      isAdmin: () => get().user?.rol === 'admin',
      
      isProfesional: () => {
        const rol = get().user?.rol;
        return rol === 'profesional' || rol === 'admin';
      },
      
      isPaciente: () => {
        const rol = get().user?.rol;
        return rol === 'paciente' || rol === 'profesional' || rol === 'admin';
      },

      isImpersonating: () => !!get().user?.impersonated_by,
    }),
    {
      name: 'neureka-auth',
      partialize: (state) => ({
        user: state.user,
        profile: state.profile,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
